import { Spinner } from "../../../../components/Spinner";
import { formatFullDate, formatTime } from "../../../../lib/utils";
import empty from "../../../../assets/images/empty_team.png";
import ResendInviteModal from "../modals/ResendInviteModal";
import CancelInviteModal from "../modals/CancelInviteModal";

const Invitations = ({
  data,
  isLoading,
  isSuccess,
  isError,
  role,
}) => {
  return (
    <div className="w-full">
      {isLoading && !isSuccess && (
        <div className="h-[55vh] w-full flex items-center justify-center">
          <Spinner />
        </div>
      )}

      {isError && !isLoading && (
        <div className="h-[45vh] w-full flex justify-center flex-col items-center">
          <p className="font-semibold text-xl text-center">
            There was an error getting the data
          </p>
          <p className="text-center">{data?.message ?? ""}</p>
        </div>
      )}

      {!isLoading && isSuccess && data?.length > 0 && (
        <div className="lg:p-10 md:p-5 p-4 bg-white h-[100%]">
          <div className="overflow-x-auto">
            <div className="w-full border min-w-[1100px] border-neutral300 rounded-lg text-sm">
              <div className="flex justify-between gap-2 text-left px-3 xl:px-6 py-2 bg-neutral3 rounded-t-lg border-b text-neutral700 font-medium w-full">
                <span className="flex-1">Name</span>
                <span className="flex-1">Email</span>
                <span className="flex-1">Role</span>
                <span className="flex-1">Date Added</span>
                {role && role !== "Editor" && (
                  <span className="flex-1 text-center">Action</span>
                )}
              </div>

              {data?.map((item, index) => {
                return (
                  <section
                    key={index}
                    className={`min-h-[60px] py-2 px-3 xl:px-6 flex gap-2 text-neutral900 items-center ${
                      index === 0 ? "border-t-0" : "border-t border-t-[#EAECF0]"
                    } hover:bg-[#F9FAFB]`}
                  >
                    <div className="flex-1 text-left">{item.name}</div>
                    <div className="flex-1 text-left truncate">
                      {item.email}
                    </div>
                    <div className="flex-1 text-left">{item.role}</div>
                    <div className="flex-1 text-left text-grey">
                      <span className="text-neutral800">
                        {formatFullDate(item.created_at)},
                      </span>{" "}
                      <span className="text-neutral600">
                        {formatTime(item.created_at)}
                      </span>
                    </div>
                    {role && role !== "Editor" && (
                      <div className="flex-1 flex space-x-2 text-center justify-center">
                        <ResendInviteModal data={item} />
                        <CancelInviteModal data={item} />
                      </div>
                    )}
                  </section>
                );
              })}
            </div>
          </div>
          {/* <PaginationComponent
            lastPage={data?.databases?.last_page!}
            currentPage={currentPage}
            handlePageChange={updatePage}
          /> */}
        </div>
      )}

      {data?.length === 0 && !isLoading &&isSuccess && (
        <div className="h-[45vh] mt-[6rem] w-full flex justify-center flex-col items-center text-center p-4">
          <img src={empty} alt="empty" />
          <p className=" font-semibold mt-4 text-darkGrey">
            No team member invited
          </p>
          <p className="text-neutral600 text-sm max-w-[360px] my-3">
            Invite your team to manage scans, monitor vulnerabilities, and keep
            your assets protected.
          </p>
        </div>
      )}
    </div>
  );
};

export default Invitations;
